var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['icon-wrapper', _vm.getSizeClass()]},[_c(_vm.iconSvg,{tag:"component",staticClass:"icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }